export const CHECKBOX_TEST_ID = "checkbox-test-id";
export const CHECKBOX_WRAPPER_TEST_ID = "checkbox-wrapper-test-id";
export const CHECKBOX_DISPLAY_NAME = "Checkbox";
